import PropTypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import { XmarkLargeSolidV6 } from "@shared/v2/Icomoon";
import UserListing from "./UserListing";

const RemoveableUser = ({ name, imageUrl, onClick }) => (
  <div className="tw-flex tw-items-center tw-gap-[8px]">
    <UserListing name={name} imageUrl={imageUrl} />
    <IconButton schema="transparent" onClick={onClick}>
      <XmarkLargeSolidV6 />
    </IconButton>
  </div>
);

RemoveableUser.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

RemoveableUser.defaultProps = {
  imageUrl: "",
};

export default RemoveableUser;
